// actionTypes.js
export const SET_VALUE_PCGP = "SET_VALUE_PCGP";
export const SET_TYPE_PCGP = "SET_TYPE_PCGP";
export const SET_CURRENT_PAGE_PCGP = "SET_CURRENT_PAGE_PCGP";
export const SET_ORDER_PCGP = "SET_ORDER_PCGP";
export const SET_SORT_FIELD_PCGP = "SET_SORT_FIELD_PCGP";
export const SET_ACTIF_PCGP = "SET_ACTIF_PCGP";
